export enum Widgets {
    AVATAR = 'avatar',
    BUTTON = 'button',
    INDENT = 'indent',
    LINE = 'line',
    SOCIAL_NETWORKS = 'social-networks',
    CHAT_BOTS = 'chat-bots',
    TEXT = 'text',
    GALLERY = 'gallery',
    SUBSCRIPTION_FORM = 'subscription-form',
    PAYMENT_FORM = 'payment',
    TIMER = 'timer',
    ACCORDION = 'accordion',
    MENU = 'menu',
    MAP = 'map',
    EDU_BANNER = 'edu-banner',
    EDU_TEACHERS = 'edu-teachers',
    AUDIO = 'audio',
    FILE = 'file',
    IMAGE = 'image',
    BEFORE_AFTER = 'before-after',
    VIDEO = 'video',
    FORM = 'form',
    TASK = 'task',
    LOGIN_EDU = 'login-edu',
    EDU_LOGIN_BUTTON = 'edu-login-button',
    TESTIMONIAL = 'testimonial',
    CODE = 'code',
    NAVIGATION = 'navigation',
    LOGO = 'logo',
    PRODUCT_CARD = 'product-card',
    SHOP_CART = 'shop-cart',
    SHOP_CART_ICON = 'shop-cart-icon',
    FIGURE = 'figure',
    CATALOG_PRODUCTS = 'catalog-products',
}

export enum WidgetsDataTypes {
    image = 'image',
    uploadImage = 'uploadImage',
    images = 'images',
    backgroundImage = 'backgroundImage',
    customPreviewFile = 'customPreviewFile',
    overlayImage = 'overlayImage',
    beforeImage = 'beforeImage',
    afterImage = 'afterImage',
    product = 'product',
}

export enum WidgetDataSubTypes {
    column = 'column',
    block = 'block',
}
